export default {
  past_seven_days: '7 Hari Terakhir',
  past_three_months: '3 Bulan Terakhir',
  previous_month: 'Bulan Sebelumnya',
  this_month: 'Bulan Ini',
  this_year: 'Tahun Ini'
};